import React from "react";
import Layout from "../../components/layout/Layout";


const RecentEditOrder = () => {

  return (
    <React.Fragment>
      <Layout title="Assign Recent Order">
        hello
      </Layout>
    </React.Fragment >
  );
};
export default RecentEditOrder;
